import { Trans } from 'next-i18next'
import { FC } from 'react'
import styles from './index.module.scss'

type Props = {
  href: string
  i18nKey: string
  upperText: string
  lowerText: string
}

export const ContextWithLink: FC<Props> = ({ href, i18nKey, upperText, lowerText }) => {
  return (
    <p className={styles.container}>
      <Trans i18nKey={i18nKey}>
        {upperText}
        <a className={styles.link} href={href} target='_blank' rel='noreferrer'>
          こちら
        </a>
        {lowerText}
      </Trans>
    </p>
  )
}
